import { createStore, combineReducers, applyMiddleware } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";

import appReducer from "./services/appReducer";
import eventsReducer from "./scenes/landingPage/components/events/services/eventsReducer";

export default createStore(
  combineReducers({
    app: appReducer,
    events: eventsReducer,
  }),
  {},
  applyMiddleware(thunk, logger),
);



// WEBPACK FOOTER //
// ./src/store.js